import { useStaticQuery, graphql } from "gatsby"
import { useLanguage } from "src/components/utils"
import { flatMap } from "lodash"
import { transformForUI } from "../transformers"

const UPDATES_CATEGORY = ["ALL", "NEWS", "PROJECTS", "TECH REVIEW"]

export default function useContent() {
    const language = useLanguage()

    // 사전에 빌드된 페이지의 데이터를 사용합니다
    const { allSitePage } = useStaticQuery(graphql`
        query {
            allSitePage(filter: {path: {regex: "/\\/updates\\/[^\\/]+\\/$/"} }) {
                edges {
                    node {
                        path
                        context {
                            title
                            slug
                            excerpt
                            content
                            date
                            categories {
                                name
                            }
                            tags {
                                name
                                wordpress_id
                            }
                            featured_media {
                                source_url
                            }
                        }
                    }
                }
            }
        }
    `)

    // 사이트 페이지 데이터를 필터링
    const categories = UPDATES_CATEGORY

    // 포스트 데이터 준비
    const postRawData = allSitePage.edges
        .filter(({ node }) => node.path.startsWith(`/${language}/updates/`))
        .map(({ node }) => {
            const post = node.context || {}
            const tags = flatMap(post.tags || [], tag => tag.name)
            
            return {
                ...post,
                tags,
                imgSrc: post.featured_media ? post.featured_media.source_url : null,
                excerpt: post.excerpt ? post.excerpt.replace(/<[^>]*>/g, '') : "",
                to: node.path
            }
        });
    
    // 변환 함수를 통해 UI에 맞게 데이터 처리
    const posts = transformForUI(postRawData, language, 'updates');

    return { categories, posts, loading: false }
}